import { alpha, useTheme } from "@mui/material";
import type { FC } from "react";
import { isPositiveFinancialBalance } from "web_myplann/Finances/Helpers/isPositiveFinancialBalance";
import type { SignedBalanceSize } from "web_myplann/Finances/Types/SignedBalanceAppearance";
import { AmountWithCurrency } from "web_myplann/Shared/Components/AmountWithCurrency";
import { alwaysSignedNumberFormatter } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	balance: number;
	size: SignedBalanceSize;
};

export const SignedBalanceAmount: FC<Props> = ({ balance, size }) => {
	const theme = useTheme();
	const { variant, suffixVariant, suffixWeight } =
		theme.finances.signedBalance[size];
	const color = isPositiveFinancialBalance(balance)
		? theme.palette.green[600]
		: theme.palette.red[600];

	return (
		<AmountWithCurrency
			amount={alwaysSignedNumberFormatter.format(balance)}
			variant={variant}
			color={color}
			suffixVariant={suffixVariant}
			suffixColor={alpha(color, theme.finances.currencySuffixAlpha)}
			suffixWeight={suffixWeight}
		/>
	);
};
